import styles from "./slider.module.css"

export type SliderOrigin = 'uk' | 'com' | 'unknown'

const sharedSlideProps = {
    buttonClassName: styles.button,
    buttonText: 'sign_up',
}

const paymentsSlide = {
    className: styles.slide1,
    title: 'payments',
    description: 'multi_currency_account',
    components: {
        br: <br />,
    },
    ...sharedSlideProps,
}

const ukCardSlide = {
    className: styles.slide2,
    title: 'banxe_card',
    description: 'banxe_card_uk_description',
    components: {
        br: <br />,
    },
    ...sharedSlideProps,
}

const ibanSlide = {
    className: styles.slide4,
    title: 'iban',
    description: 'get_dedicated_iban',
    ...sharedSlideProps,
}

export const resolveSliderOrigin = (originDomain?: string | null): SliderOrigin => {
    if (!originDomain) return 'unknown'

    const value = originDomain.trim().toLowerCase()
    if (!value) return 'unknown'

    let hostname = value
    try {
        hostname = new URL(value.includes('://') ? value : `https://${value}`).hostname
    } catch {
        return 'unknown'
    }

    if (hostname === 'banxe.uk' || hostname.endsWith('.banxe.uk')) return 'uk'
    if (hostname === 'banxe.com' || hostname.endsWith('.banxe.com')) return 'com'

    return 'unknown'
}

export const getSlides = (originDomain?: string | null, isUkUser = false) => {
    const origin = resolveSliderOrigin(originDomain)

    if (origin === 'uk') return [paymentsSlide, ukCardSlide, ibanSlide]
    if (origin === 'com') return [paymentsSlide, ibanSlide]
    if (isUkUser) return [paymentsSlide, ukCardSlide, ibanSlide]

    return [paymentsSlide, ibanSlide]
}
